import React, { useCallback, useState } from 'react';
import { Button, Space, message, Tooltip, Breadcrumb, Table, Spin } from 'antd';
import { CardLayout, TableWrapper, CrmEditModal } from 'components/molecules';
import { addNewSearch } from 'utils/utils';
import { useLocation, useNavigate } from 'react-router';
import { usePopupManager } from 'react-popup-manager';
import { ColumnsType } from 'antd/lib/table/interface';
import qs from 'query-string';
import { TotalNumMenu } from 'components/atoms';
import { useTableInfo, useCrm } from 'hooks';
import { INIT_PAGESIZE } from 'commons/constants';
import CrmSearchBox from './SearchBox'
import axios from 'axios';
import { endpoints } from 'services';
import { SERVER_URL } from 'commons/constants';
import moment from 'moment';
import { fetcher } from 'services';
import * as XLSX from 'xlsx';

export interface  CrmProps {}

const  Crm = ({}:  CrmProps): React.ReactElement => {
 /* ======================================================
   * hooks
   * ====================================================== */
 const navigate = useNavigate();
 const location = useLocation();
 const { crmList, searchResult, refetch } = useCrm();  

 /* ======================================================
  * variables
  * ====================================================== */
 const { open } = usePopupManager();
 const [isLoding, setIsLoading] = useState<boolean>(false);   

 const searchParams = qs.parse(location.search);
 const columns: ColumnsType<CrmListDto> = [
   {
     title: '번호',
     dataIndex: 'id',
     key: 'id',
     width: '70px',
     align: 'center',
   },  
   {
     title: '고객사',
     dataIndex: 'company_name',
     key: 'company_name',
     width: 'auto',
     align: 'left', 
     ellipsis: true,    
   },  
   {
     title: '이름(구분)',
     dataIndex: 'name',
     key: 'name',
     width: 'auto',
     align: 'left',
     ellipsis: true,
     render: (name, record) => {
      return (
        <>
          {name}{record.crm_type_name && '('+record.crm_type_name+')'}
        </>        
      )
     }       
   },
   {
    title: '전화번호',
    dataIndex: 'tel',
    key: 'tel',
    width: '120px',
    align: 'center',
    ellipsis: true,
  },   
  {
    title: '핸드폰',
    dataIndex: 'phone',
    key: 'phone',
    width: '120px',
    align: 'center',
    ellipsis: true,
  },     
   {
     title: '이메일',
     dataIndex: 'email',
     key: 'email',
     width: '200px',
     align: 'left',
     ellipsis: true,
   },
   {
    title: '직급',
    dataIndex: 'position',
    key: 'position',
    width: '100px',
    align: 'center',
    ellipsis: true,
  },   
   {
    title: '부서',
    dataIndex: 'department',
    key: 'department',
    width: '100px',
    align: 'center',
    ellipsis: true,
  },
  {
    title: '프로젝트',
    key: 'project',
    dataIndex: 'project',
    width: '100px',
    align: 'center',
    onCell: (record) => {
      return {
          onClick: (e) => {
            e.stopPropagation();
            if (record.project > 0)
              window.location.href = "/b2b/confirm?crm=" + record.id;
          },
      };
    }, 
    render: (project, record) => {
     return (
       <>
         {project}건
       </>
     )
   } 
  },   
   {
     title: '성과백신',
     key: 'pml',
     dataIndex: 'pml',
     width: '100px',
     align: 'center',
     onCell: (record) => {
      return {
          onClick: (e) => {
            e.stopPropagation();
            if (record.pml > 0)
              window.location.href = "/b2c/pml?crm=" + record.id;
          },
      };
    }, 
     render: (pml, record) => {
       return (
         <>
         {pml}건
         </>
       )
     } 
   },
   {
    title: '공개과정',
    key: 'b2c',
    dataIndex: 'b2c',
    width: '100px',
    align: 'center',
    onCell: (record) => {
      return {
          onClick: (e) => {
            e.stopPropagation();
            if (record.b2c > 0)
              window.location.href = "/b2c/lecture?crm=" + record.id;
          },
      };
    }, 
    render: (b2c, record) => {
     return (
       <>{b2c}건</>
     )
   }  
  },
 ];

 /* ======================================================
  * events
  * ====================================================== */    
 const onClickRegister = () => {

  open(CrmEditModal, {
    id: 0,
    onClose: (isOk) => {
      if (isOk) {
        refetch();
      };
    },
  }); 

 }

 const onChangePageInfo = (pageNo: number, pageSize: number) => {
   navigate({
     ...location,
     search: addNewSearch(location.search, { pageNo, pageSize }),
   });
 };  

 const onRowClick = useCallback((record, index) => {
   return {
     onClick: () => {
      open(CrmEditModal, {
        id: Number(record.id),     
        onClose: (isOk) => {
          if (isOk) {
            refetch();
          }
        },
      }); 
     },
   };
 }, []);


 const onExcelDownload = () => {
  setIsLoading(true); 
  fetcher.crm.postCrmList({
    pageNo: 1,
    pageSize: 0,
    searchValue: searchParams.search ? String(searchParams.search) : '',        
    gubun: searchParams.gubun ? String(searchParams.gubun) : '',    
  })
  .then((res) => {
      switch (res.code) {
          case 200:
          if (!!res.result) {
            const book = XLSX.utils.book_new();
            const nurses = XLSX.utils.json_to_sheet(
              res.result.list.map((item, index) => {
                return {
                  '번호' : item.id,
                  '고객사' : item.company_name,
                  '이름': item.name,
                  '구분': item.crm_type_name,
                  '전화번호': item.tel,
                  '핸드폰': item.phone,
                  '이메일': item.email,
                  '직급': item.position,
                  '부서': item.department,
                  '프로젝트(건수)': item.project,
                  '성과백신(건수)': item.pml,
                  '공개과정(건수)': item.b2c,
                }
              }), 
              { 
                header : [
                  '번호',
                  '고객사',
                  '이름',
                  '구분',
                  '전화번호',
                  '핸드폰',
                  '이메일',
                  '직급',
                  '부서',
                  '프로젝트(건수)',
                  '성과백신(건수)',
                  '공개과정(건수)',                  
                ], 
                skipHeader : false 
              } 
            );
        
            nurses["!cols"] = [
              { wpx : 60 } 
            , { wpx : 150 } 
            , { wpx : 100 }  
            , { wpx : 100 }  
            , { wpx : 120 } 
            , { wpx : 150 } 
            , { wpx : 100 } 
            , { wpx : 100 } 
            , { wpx : 100 } 
            , { wpx : 100 } 
            , { wpx : 100 } 
            , { wpx : 100 } 
            ]
        
            XLSX.utils.book_append_sheet( book, nurses, "NURSES" );
        
            XLSX.writeFile( book, "고객_담당자.xlsx" ); 
          }
          break;
          default:  
          break;
      };
      setIsLoading(false);         
  });   
 }  

  /* ======================================================
   * hooks
   * ====================================================== */
  const { pagination, onTableChange } = useTableInfo({
    pageInfo: {
      pageNo: Number(searchParams.pageNo) || 1,
      pageSize: Number(searchParams.pageSize) || INIT_PAGESIZE,
    },
    datas: crmList,
    totalCount: searchResult.totalCount,
    onChangePageInfo,
  });

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <CardLayout title={(
      <Breadcrumb>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>고객</Breadcrumb.Item>
        <Breadcrumb.Item>교육담당자</Breadcrumb.Item>
    </Breadcrumb>      
    )}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <CrmSearchBox />
          <Spin spinning={isLoding} tip="처리중입니다. 잠시만 기다려 주세요." size="large">
            <TotalNumMenu totalNum={searchResult.totalCount} useRegister useExcelDownload onUseRegister={onClickRegister} onDownloadExcel={onExcelDownload}/>
            <TableWrapper isSearch={!!searchParams.search || !!searchParams.lecturer_type || !!searchParams.lecturer_category}>
              <Table
                tableLayout="fixed"
                dataSource={crmList}
                columns={columns}
                pagination={pagination}
                onChange={onTableChange}
                onRow={onRowClick}
                style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
                className="columnCenterFixTable clickable"
                showSorterTooltip={false}
                rowKey={'id'}
              />
            </TableWrapper>  
          </Spin>
        </Space>                
    </CardLayout>
  )
};

export default  Crm;    